
import Vue from 'vue'
import BasicDialog from '@components/dialogs/BasicDialog.vue'
import { HireDesignerRequest } from '~/domain/interfaces'
import AppActions from '@/domain/constants/AppActions'

const ContactDialog = Vue.extend({
  components: {
    BasicDialog,
  },
  props: {
    diagramOwner: {
      type: Object,
      required: true,
    },
    contactDialogVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      contactDesignerIsComplete: false,
      contactDesignerIsLoading: false,
      defaultModalData: {
        valid: true,
        emailRules: [
          (v: string): string | boolean =>
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            'E-mail must be valid',
        ],
        nameRules: [
          (v: string): string | boolean => !!v || 'Required',
          (v: string): string | boolean =>
            /^[a-zA-Z\s]*$/.test(v) || 'Name must contain only letters',
        ],
        textRules: [(v: string): string | boolean => !!v || 'Required'],
        name: '',
        email: '',
        message: '',
        company: '',
        game: '',
      },
      modalData: {} as any,
      sendCopy: false,
      additionalFields: [
        { label: this.$t('hireModalCompany'), model: 'company', menu: false },
        { label: this.$t('hireModalGame'), model: 'game', menu: false },
      ],
    }
  },
  watch: {
    contactDialogVisible(newVal) {
      if (newVal) {
        this.modalData = { ...this.defaultModalData }
      }
    },
  },
  async mounted() {
    try {
      // @ts-ignore
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e)
    }
  },
  beforeDestroy() {
    // @ts-ignore
    this.$recaptcha.destroy()
  },
  methods: {
    removeAsterisk(text) {
      if (text.endsWith('*')) {
        return text.slice(0, -1)
      }

      return text
    },
    async sendModalContactData(): Promise<void> {
      const valid = (this.$refs.contactForm as HTMLFormElement).validate()

      if (valid) {
        try {
          this.contactDesignerIsLoading = true

          if (this.diagramOwner && this.diagramOwner.username) {
            // check recaptcha
            // @ts-ignore
            const recaptchaToken = await this.$recaptcha.execute('hireDesigner')

            const params: HireDesignerRequest = {
              fullName: this.modalData.name,
              email: this.modalData.email,
              company: this.modalData.company,
              projectName: this.modalData.game,
              designerUsername: this.diagramOwner.username,
              message: this.modalData.message,
              recaptchaToken,
              sendCopy: this.sendCopy,
            }

            await this.$store.dispatch('designers/hireDesigner', {
              context: this,
              params,
            })

            this.$store.dispatch(AppActions.TRACK_SEGMENT_EVENT, {
              context: this,
              params: {
                name: 'Community - Send message',
                category: 'Community',
                action: 'Send message',
              },
            })
            this.contactDesignerIsLoading = false
            this.contactDesignerIsComplete = true
            // @ts-ignore
            await this.$recaptcha.reset()
          }
        } catch (error) {
          this.contactDesignerIsLoading = false
          this.contactDesignerIsComplete = false
          // @ts-ignore
          await this.$recaptcha.reset()
        }
      }
    },
    extractFirstName(name) {
      const names = name?.split(' ')

      if (names?.length > 1) {
        return names[0]
      } else {
        return name.trim() === '' ? 'the user' : name
      }
    },
    closeDialog() {
      this.contactDesignerIsComplete = false
      this.$emit('close-dialog')
    },
    handleClickOutside(event, index) {
      const target = event.target as HTMLElement
      const isAdditionalFieldInput = target.closest('.additional-data__field')
      const field = this.additionalFields[index]

      if (!this.modalData[field.model] && !isAdditionalFieldInput) {
        field.menu = false
      }
    },
    showInputField(index) {
      this.additionalFields[index].menu = true
    },
  },
})

export default ContactDialog
